import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Icon } from '@fluentui/react';
import { useHistory } from "react-router-dom";
import PropTypes from 'prop-types';

import book_icon from '../../../../../../images/ico_book_full.png';
import co_icon from '../../../../../../images/ico_co_full.png';
import ep_icon from '../../../../../../images/ico_ep_full.png';
import kpi_icon from '../../../../../../images/ico_kpi_full.png';
import { __onGoToBoardEP, __onGoToBook, __onGoToKPIHome } from '../../../../../../common/SystemRedirections';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { __onGetDataGridHtmlContainer } from '../../../../../../common/CommonFuctions';
import { useTranslation } from 'react-i18next';

function PRODUCTS(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const { 
        inputParam_ElementId = false,
        inputParam_HideHeader = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
        inputParam_ComponentContent = null,
        inputParam_UseFake = null
    } = props;

    const renderIcon = (text, iconName, icon) => {
      return <div id="kpiico" className="float-right divproduct cursor-pointer" style={{backgroundImage: `url(${icon})`, height: '45px', width: '45px', backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover"}}>
        <Row>
            <Col className='mx-auto text-center' style={{paddingTop: '3px'}}>
                <Icon style={{ color: "white", fontSize: "19px", fontWeight: "400", fontFamily: "FabricMDL2Icons" }} iconName={iconName} />
            </Col>
        </Row>
        <Row style={{marginTop: '-8px'}}>
            <Col className='mx-auto pb-3 text-center' style={{ color: "white", fontSize: "12px", fontWeight: "bold", fontFamily: "Segoeui" }}>
                { text }
            </Col>
        </Row>
      </div>
    }

    const renderContent = () => {
      return <>
          <Row className='h-10 mx-1' style={{backgroundColor: "#efefef", opacity: inputParam_UseFake ? ".4" : ""}}>
            <Col className='col-auto m-auto'></Col>
            <Col xl={10} className='font-weight-bold m-auto'>
              <Row>
                <Col xl={4}>{t('data-lang-lbl-critical')}</Col>
                <Col xl={4}>{t('data-lang-lbl-operational')}</Col>
                <Col xl={4}>{t('data-lang-lbl-minor')}</Col>
              </Row>
            </Col>
          </Row>
          <Row className='border mx-1 mb-1 h-21' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
            <Col className='col-auto  m-auto' onClick={() => __onGoToKPIHome(history)}>
              {renderIcon('', '', kpi_icon)}
            </Col>
            <Col xl={10} className='m-auto'>
              <Row>
                <Col className='font-weight-bold'>SG3 KPI - Tableros de gestión</Col>
              </Row>
              <Row>
                <Col xl={4} className='border'>100</Col>
                <Col xl={4} className='border'>70</Col>
                <Col xl={4} className='border'>5</Col>
              </Row>
            </Col>
          </Row>
          <Row className='border mx-1 mb-1 h-21' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
            <Col className='col-auto m-auto' onClick={() => __onGoToBoardEP(inputParam_ElementId)}>
              {renderIcon('', '', ep_icon)}
            </Col>
            <Col xl={10} className='m-auto'>
              <Row>
                <Col className='font-weight-bold'>SG3 PAY - Gestión de pagos</Col>
              </Row>
              <Row>
                <Col xl={4} className='border'>100</Col>
                <Col xl={4} className='border'>70</Col>
                <Col xl={4} className='border'>5</Col>
              </Row>
            </Col>
          </Row>
          <Row className='border mx-1 mb-1 h-21' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
            <Col className='col-auto m-auto'>
              {renderIcon('', '', co_icon)}
            </Col>
            <Col xl={10} className='m-auto'>
              <Row>
                <Col className='font-weight-bold'>SG3 CO - Control de obligaciones</Col>
              </Row>
              <Row>
                <Col xl={4} className='border'>100</Col>
                <Col xl={4} className='border'>100</Col>
                <Col xl={4} className='border'>100</Col>
              </Row>
            </Col>
          </Row>
          <Row className='border mx-1 h-21' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
            <Col className='col-auto m-auto' onClick={() => __onGoToBook(5, history)}>
              {renderIcon('', '', book_icon)}
            </Col>
            <Col xl={10} className='m-auto'>
              <Row>
                <Col className='font-weight-bold'>SG3 Book - Libro de comunicaciones</Col>
              </Row>
              <Row>
                <Col xl={4} className='border'>100</Col>
                <Col xl={4} className='border'>60</Col>
                <Col xl={4} className='border'>30</Col>
              </Row>
            </Col>
          </Row>
      </>
    }

    return (
      <>
        {
          !inputParam_UseFake &&
          <Card className='h-100' style={{borderColor: "red"}}>
            {
              !inputParam_HideHeader &&
              <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                  <b>{ (inputParam_ComponentContent && inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-coveragesg3plus')}</b>
                  <div className='toolbar d-flex'>
                      <HEADER_TOOLBAR
                        inputParam_BoardStructure={inputParam_BoardStructure}
                        inputParam_Container={inputParam_Container}
                      />
                  </div>
                </Card.Title>
              </Card.Header>
            }
            <Card.Body className='h-100 p-0 m-0'>
              {renderContent()}
            </Card.Body>
          </Card>
        }
        {inputParam_UseFake && renderContent()}
      </>
    );
}

PRODUCTS.propTypes = {
  inputParam_UseFake: PropTypes.bool,
  inputParam_ElementId: PropTypes.number,
  inputParam_HideHeader: PropTypes.bool,
  inputParam_BoardStructure: PropTypes.object,
  inputParam_Container: PropTypes.object,
  inputParam_ComponentContent: PropTypes.object,
  inputParam_Height: PropTypes.number,
};

export default PRODUCTS;


